import { Component, OnInit, Input, PLATFORM_ID, Inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-file-download-modal',
  templateUrl: './file-download-modal.component.html',
  styleUrls: ['./file-download-modal.component.scss']
})
export class FileDownloadModalComponent implements OnInit {
  @Input() petName: string;
  @Input() title: string;
  @Input() content: string;
  @Input() fileUrl: string;
  @Input() downloadEventName: string;
  private isBrowser: boolean;

  constructor(
    public activeModal: NgbActiveModal,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { 
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  trackEvent(event: string) {
    if (!this.isBrowser) return;
    window.analytics.track(event);
  }

  ngOnInit(): void {
  }

}
